module.exports = (__webpack_require__(25))(42);


//////////////////
// WEBPACK FOOTER
// delegated ./lib/rlink-router/component.jsx from dll-reference forms
// module id = 570
// module chunks = 0